
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
    MemberPushSettingService,
    MemberPushSettingDto,
    Int32EntityDto,
} from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
class PageMemberPushSettingInput extends PagedRequestDto {
    schoolName: string;
}
@Component({
    name: "expirationReminderSettings",
    components: {
        Pagination
    },
})
export default class expirationReminderSettings extends PagedListBase<
    PageMemberPushSettingInput,
    MemberPushSettingDto
> {
    private memberPushSettingService = new MemberPushSettingService();
    request = new PageMemberPushSettingInput();
    private editDialogVisible = false;
    private isLoading = false;
    editRow = new MemberPushSettingDto();
    dayList = [
        { name: "不提醒", value: 0 },
        { name: "提前1天", value: 1 },
        { name: "提前2天", value: 2 },
        { name: "提前3天", value: 3 },
        { name: "提前4天", value: 4 },
        { name: "提前5天", value: 5 },
        { name: "提前6天", value: 6 },
        { name: "提前7天", value: 7 },
        { name: "提前10天", value: 8 },
        { name: "提前15天", value: 9 },
        { name: "提前20天", value: 10 },
        { name: "提前25天", value: 11 },
        { name: "提前30天", value: 12 },
    ];
    dayValue = 0;
    orderList = [
        { name: "不提醒", value: 0 },
        { name: "每天一次", value: 1 },
        { name: "每2天一次", value: 2 },
        { name: "每3天一次", value: 3 },
        { name: "每5天一次", value: 4 },
        { name: "每7天一次", value: 5 },
    ];
    orderValue = 0;
    private mounted() {
        this.getAll();
    }
    getpage(): void {
        this.getAll();
    }
    private async getAll() {
        this.isLoading = true;
        try {
            this.list = await (
                await this.memberPushSettingService.getAllSettings(
                    this.request.schoolName,
                    0,
                    999
                )
            ).items;
        } finally {
            this.isLoading = false;
        }
    }

    //提交设置
    submitSetting() {
        this.memberPushSettingService
            .updateMemberPushSetting(this.editRow)
            .then(() => {
                this.$message.success("设置成功");
                this.getAll();
            })
            .catch((error) => {
                this.$message.success("设置失败");
            })
            .finally(() => {
                this.editDialogVisible = false;
            });
    }
    //开关控制
    openSwitch(row: MemberPushSettingDto) {
        var int32EntityDto = new Int32EntityDto();
        int32EntityDto.id = row.tenantId;
        this.memberPushSettingService
            .openOrCloseSetting(int32EntityDto)
            .then(() => {
                this.$message.success(
                    row.settingIsOpen == false ? "关闭成功" : "开启成功"
                );
                this.getAll();
            })
            .catch((error) => {
                this.$message.success(
                    row.settingIsOpen == false ? "关闭失败" : "开启失败"
                );
            });
    }

    colse() {
        this.isLoading = true;
    }

    private handleEdit(row: MemberPushSettingDto) {
        this.editRow = JSON.parse(JSON.stringify(row));
        if (this.editRow.id == 0) {
            this.editRow.settingIsOpen = true;
            this.editRow.daysInAdvance = 7;
            this.editRow.intervalDays = 2;
            this.editRow.isOpentAfterPush = false;
            this.editRow.beforePushTime = "16:30";
            this.editRow.afterPushTime = "16:30";
            this.editRow.tenantId = row.tenantId;
        }
        this.editDialogVisible = true;
    }

    private async handleConfirmEdit() {
        this.isLoading = true;
        try {
            await this.memberPushSettingService.updateMemberPushSetting(
                this.editRow
            );
            // this.$listeners.find((x) => x.tenantId === this.editRow.tenantId).annualCost =
            //     this.editRow.annualCost;
            this.$message.success("保存成功");
            this.editDialogVisible = false;
        } finally {
            this.isLoading = false;
        }
    }
}
